import { InternalWorkoutReview, WorkoutSelection } from '../../../entities';
import { IWorkoutSelectionRepository } from '../interfaces';

export class InMemoryWorkoutSelectionRepository implements IWorkoutSelectionRepository {
    private workoutSelections: WorkoutSelection[] = [];

    public addReview(workoutId: string, review: InternalWorkoutReview): Promise<void> {
        throw new Error('Method not implemented.');
    }

    public addPowerReview(workoutId: string, review: InternalWorkoutReview): Promise<void> {
        throw new Error('Method not implemented.');
    }

    public async add(workoutSelection: WorkoutSelection): Promise<WorkoutSelection> {
        return new Promise<WorkoutSelection>((resolve, reject) => {
            this.workoutSelections.push(workoutSelection);
            resolve(workoutSelection);
        });
    }

    public async get(uid: string): Promise<WorkoutSelection | undefined> {
        return new Promise<WorkoutSelection | undefined>((resolve, reject) => {
            resolve(this.workoutSelections.find((a: WorkoutSelection) => a.uniqueReference === uid));
        });
    }

    public update(workoutSelection: WorkoutSelection): Promise<WorkoutSelection> {
        return new Promise<WorkoutSelection>((resolve, reject) => {
            const index = this.workoutSelections.findIndex((a: WorkoutSelection) =>
                a.uniqueReference === workoutSelection.uniqueReference);
            if (index < 0) {
                this.add(workoutSelection).catch((e) => { /* no-op */ });
            }
            this.workoutSelections[index] = workoutSelection;
            resolve(this.workoutSelections[index]);
        });
    }

    public getAll(): Promise<WorkoutSelection[]> {
        return new Promise((resolve) => {
            resolve(this.workoutSelections);
        });
    }

    public filter(): Promise<WorkoutSelection[]> {
        throw new Error('Not implemented yet.');
    }
}
